// extracted by mini-css-extract-plugin
export default {"root":"modal_root__tO9BZ","wrapper":"modal_wrapper__VSipt","closeButton":"modal_closeButton__ptBX+"};